import { render, staticRenderFns } from "./workpackage-pricing-groups.vue?vue&type=template&id=c7af22a4&scoped=true"
import script from "./workpackage-pricing-groups.vue?vue&type=script&lang=js"
export * from "./workpackage-pricing-groups.vue?vue&type=script&lang=js"
import style0 from "./workpackage-pricing-groups.vue?vue&type=style&index=0&id=c7af22a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7af22a4",
  null
  
)

export default component.exports